import utilitiesPlugin from './plugins/utilities.js';
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import '../styles/main.css';
import './plugins/axios';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fad } from '@fortawesome/pro-duotone-svg-icons';
import { useAuthStore } from './stores/index.js';
import Toast, { useToast } from 'vue-toastification';
import "vue-toastification/dist/index.css";

// Add FontAwesome icons to library
library.add(fad);

// Create Pinia store
const pinia = createPinia();

// Create Vue app
const app = createApp({});

// Use Pinia
app.use(pinia);

// Configure and use Vue Toastification
app.use(Toast, {
  position: 'bottom-right'
});
app.config.globalProperties.$toast = useToast();

// Use utilities plugin (replaces D2Kit mixins)
app.use(utilitiesPlugin);

// Register FontAwesome component globally
app.component('FontAwesome', FontAwesomeIcon);

// Helper function to convert PascalCase to kebab-case
function toKebabCase(str) {
  return str
    .replace(/([a-z0-9])([A-Z])/g, '$1-$2')
    .replace(/([A-Z])([A-Z][a-z])/g, '$1-$2')
    .toLowerCase();
}

// Import all components globally
const modules = import.meta.glob(['./components/**/*.vue', '/Views/**/*.vue'], { eager: true });
Object.entries(modules).forEach(([path, module]) => {
  try {
    const component = module.default;
    if (!component) return;

    const name = path.split('/').pop().split('.')[0];
    const kebabName = toKebabCase(name);
    console.log(`Registering component: ${kebabName} from ${path}`);
    app.component(kebabName, component);
  } catch (error) {
    console.error('Error importing module:', path, module, error);
    return;
  }
});

// Initialize auth store with window data immediately after Pinia is set up
const authStore = useAuthStore();
authStore.initialize();

// Wait for CSS to load before mounting
window.addEventListener('load', () => {
    // Mount the app
    app.mount('#vue-wrapper');

    setTimeout(() => {
        // Remove loading cover
        const elem = document.getElementById('loadCover');
        if (elem) {
            elem.parentNode.removeChild(elem);
        }
    }, 250);
});



